import { css } from '@emotion/css';

import { AI_COLORS } from '../../consts';

export const aiActionButtonIconColor = css`
  fill: ${AI_COLORS.royalBlue};
`;

export const aiActionButtonTextStyles = css`
  background: linear-gradient(
    90deg,
    ${AI_COLORS.royalBlue} 0%,
    ${AI_COLORS.neonPurple} 53.13%,
    ${AI_COLORS.barney} 100%
  );
  background-clip: text;
  text-fill-color: transparent;
`;
